import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import AddInvoiceFileField from './AddInvoiceFileField.vue'
import { UploadedFileType } from '@/types/partials'

import { useAdviceDocuments } from '@/composables/useAdviceDocuments'

interface IProps {
    error?: boolean
    disableRemove?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    error: { type: Boolean, required: false, default: false },
    disableRemove: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { error: boolean, disableRemove: boolean }
const {
    removeInvoiceFile,
    addInvoiceFile,
    setInvoiceValue,
    setInvoiceNumber,
    fetchInvoiceData,
    invoiceValue,
    invoiceFile,
    setKsefNumber,
} = useAdviceDocuments()



const showField = ref<boolean>(false)
const inputInvoiceValue = ref<string>('')

fetchInvoiceData().then(() => {
    inputInvoiceValue.value = invoiceValue.value
    showField.value = true
})

const invoiceFilePresent = computed(() => {
    if (invoiceFile.value) {
        return Object.keys(invoiceFile.value).length > 0
    }
    return false
})
const onFilesUpload = (files: UploadedFileType[]) => {
    addInvoiceFile(files[0])
}
const onInputChange = (inputValue: string) => {
    setInvoiceValue(inputValue)
}
const onInvoiceNumberChange = (inputValue: string) => {
    setInvoiceNumber(inputValue)
}
const onKsefNumberChange = (inputValue: string) => {
    setKsefNumber(inputValue)
}

return (_ctx: any,_cache: any) => {
  return (showField.value)
    ? (_openBlock(), _createBlock(AddInvoiceFileField, _mergeProps({ key: 0 }, props, {
        "input-value": inputInvoiceValue.value,
        "file-present": _unref(invoiceFilePresent),
        "file-name": _unref(invoiceFile).name,
        onFileRemove: _unref(removeInvoiceFile),
        onFilesUpload: onFilesUpload,
        onInputChange: onInputChange,
        onInvoiceNumberChange: onInvoiceNumberChange,
        onKsefNumberChange: onKsefNumberChange
      }), null, 16, ["input-value", "file-present", "file-name", "onFileRemove"]))
    : _createCommentVNode("", true)
}
}

})